import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2, Video } from 'lucide-react';
import { apiClient, resolveFileUrl } from '../services/api';
import { Layout } from './Home';

const PublicGalleryPage = () => {
  const { slug } = useParams();
  const [g, setG] = useState(null);
  const [err, setErr] = useState(null);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    apiClient.get(`/galleries/public/${slug}`)
      .then((r) => setG(r.data))
      .catch(() => setErr('This gallery is private or does not exist.'));
  }, [slug]);

  if (err) return <Layout><div className="max-w-6xl mx-auto px-6 py-24 text-center text-[#0b1a2e]">{err}</div></Layout>;
  if (!g) return <Layout><div className="py-24 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#0f5c3d]" /></div></Layout>;

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="text-xs font-semibold tracking-[0.3em] text-[#0f5c3d] uppercase">Emerald Corporates</div>
        <h1 className="mt-2 text-4xl sm:text-5xl text-[#0b1a2e]" style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}>{g.title}</h1>
        {g.description && <p className="mt-3 text-[#0b1a2e]/70 max-w-2xl">{g.description}</p>}

        {g.items.length === 0 ? (
          <div className="mt-12 text-center text-[#0b1a2e]/50">This gallery is empty.</div>
        ) : (
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {g.items.map((it) => (
              <button key={it.id} onClick={() => setLightbox(it)} data-testid="public-gallery-item"
                className="aspect-square bg-white/50 rounded-lg overflow-hidden hover:opacity-90 transition relative">
                {it.kind === 'image' ? (
                  <img src={resolveFileUrl(it.thumb_url || it.url)} alt={it.filename} className="w-full h-full object-cover" loading="lazy" />
                ) : (
                  <>
                    <video src={resolveFileUrl(it.url)} className="w-full h-full object-cover" muted preload="metadata" />
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none"><Video className="w-8 h-8 text-white drop-shadow" /></div>
                  </>
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      {lightbox && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          {lightbox.kind === 'image' ? (
            <img src={resolveFileUrl(lightbox.url)} alt="" className="max-w-full max-h-full object-contain" />
          ) : (
            <video src={resolveFileUrl(lightbox.url)} controls autoPlay className="max-w-full max-h-full" />
          )}
        </div>
      )}
    </Layout>
  );
};

export default PublicGalleryPage;
